import { ITechnicalReportData, ITechnicalReport } from './technical.report.types';
import { ValidationMessage, IValidationMessage } from '../common';

export class TechnicalReportData implements ITechnicalReportData {

    selectedReport: ITechnicalReport
    selectedKey: string
    grantInfo: any
    grantData: any
    impact: Array<any>
    grantTemplate: any
    finalReport: any
    language: string
    showValidationDilog: boolean
    isStartingPeriod: boolean
    validationMessages: Array<IValidationMessage>
    selectedGrant: any;
    TechnicalReportId: any;
    techReportTemplate: any
    documentTags: Array<any>;
    documentCategories: Array<any>;

    constructor(report: ITechnicalReportData) {
        this.selectedReport = report.selectedReport || {} as ITechnicalReport;
        this.grantInfo = report.grantInfo || {};
        this.grantData = report.grantData || {};
        this.impact = report.impact || [];
        this.finalReport = report.finalReport || {};
        this.grantTemplate = report.grantTemplate || {};
        this.language = report.language || localStorage.getItem("language") || "en-US";
        this.selectedKey = report.selectedKey || "summary";
        this.showValidationDilog = report.showValidationDilog || false
        this.isStartingPeriod = report.isStartingPeriod;
        this.validationMessages = (report.validationMessages || []).map((x) => new ValidationMessage(x))
        this.TechnicalReportId = report.TechnicalReportId;
        this.techReportTemplate = report.techReportTemplate;
        this.documentTags = report.documentTags || [];
        this.documentCategories = report.documentCategories || [];
    }
}

/** class for Technical Report */
export class TechnicalReport implements ITechnicalReport {
    TechnicalReportId: number
    GrantId: number
    Title: string
    Description: string
    StartDate: Date
    EndDate: Date
    DueDate: Date
    WorkFlowStatusId: number
    CreatedById: string
    CreatedDate: Date
    WorkflowInfo: any
    Comments: string
    IsFinalPeriod: number
    UniqueID: string
    RevisionNumber: number
    UpdatedById: string
    UpdatedDate: Date
    IsLocked: any
    GrantAmendmentId: number
    AmendmentCode: string
    TechnicalRevisionNo: number
    Subject: string
    notify: boolean
    constructor(report: ITechnicalReport) {
        this.TechnicalReportId = report.TechnicalReportId;
        this.GrantId = report.GrantId;
        this.Title = report.Title;
        this.Description = report.Description;
        this.StartDate = report.StartDate;
        this.EndDate = report.EndDate;
        this.DueDate = report.DueDate;
        this.WorkFlowStatusId = report.WorkFlowStatusId;
        this.CreatedById = report.CreatedById;
        this.CreatedDate = report.CreatedDate;
        this.WorkflowInfo = report.WorkflowInfo;
        this.Comments = report.Comments;
        this.IsFinalPeriod = report.IsFinalPeriod;
        this.UniqueID = report.UniqueID;
        this.UpdatedById = report.UpdatedById;
        this.UpdatedDate = report.UpdatedDate;
        this.RevisionNumber = report.RevisionNumber;
        this.IsLocked = report.IsLocked;
        this.GrantAmendmentId = report.GrantAmendmentId;
        this.AmendmentCode = report.AmendmentCode;
        this.TechnicalRevisionNo = report.TechnicalRevisionNo;
        this.Subject = report.Subject;
        this.notify = report.notify;
    }
}
